import React, { PropsWithChildren } from 'react'
import classes from './Table.module.scss'
import { getCellStyle } from '@/components/ui/Table/utils'

export type HeaderCellProps = PropsWithChildren<{ size?: number | string; isCentered?: boolean }>

const HeaderCell = ({ size = 1, isCentered = false, children }: HeaderCellProps) => (
  <div className={classes.headerCell} style={getCellStyle(size, isCentered)}>
    {children}
  </div>
)

export default HeaderCell
